module.exports = {
	baseRouter: '',
	virtualList:[
		{
			title:'',
			list:[
				{
					name:'Studio Executive',
					img:'0.jpg',
					link:'https://beyond.3dnest.biz/play/?m=2d025e6a_vy6n_b6f9',
				}, {
					name:'One Bedroom Deluxe',
					img:'1.jpg',
					link:'https://beyond.3dnest.biz/play/?m=91f4c132_e04p_b6f9',
				},
				{
					name:'Two Bedroom Deluxe',
					img:'2.jpg',
					link:'https://beyond.3dnest.biz/silversea/play/?m=d8bca792_knPW_b6f9&_tagdistance=2',
				}, {
					name:'Three Bedroom Premier',
					img:'3.jpg',
					link:'https://beyond.3dnest.biz/silversea/play/?m=500b7bfc_0AJW_b6f9&_tagdistance=2',
				}
			],
		},
		// {
		// 	title:'TOWER B',
		// 	list:[
		// 		{
		// 			name:'STUDIO: 37m2',
		// 			img:'3.jpg',
		// 			link:'https://beyond.3dnest.biz/silversea/newhouse/?m=aabf4938_9pSh_b6f9_CJU&lang=3',
		// 		}
		// 	],
		// },
	],
};
